import React from "react";

const DeploymentsPage: React.FC = () => {
  return <div className="p-6 space-y-6">DeploymentsPage</div>;
};

export default DeploymentsPage;
